export default "__VITE_PUBLIC_ASSET__5bba3682__"